import React, { useState, useEffect } from 'react'
import { LogBox, StyleSheet, View } from 'react-native'

import { useFormik } from 'formik'
import * as Yup from 'yup'

import {
    ErrorMessage,
    TextInputExtended,
    Button,
    Space,
    Title,
    ReturnFooter
} from '@sart/components'
import { useContent } from '@sart/content'
import { prettyErrorMessage } from '@sart/utilities'
import client, { useClient } from '@sart/client'
import { adaptive, colors, typography } from '@sart/styles'

export default function UpdateReceipt(props) {
    const { navigation } = props
    const {
        cache: {
          customer
        } = {}
    } = useClient()
    const [newCode, setNewCode] = useState('')
    const [loading, setLoading] = useState(false)
    const [updateProduct, setUpdateProduct] = useState({})

    const content = useContent()

    

    useEffect(() => void fetchUpdateProduct(),[])

    const formik = useFormik({
        initialValues: {
          vatCode: (customer && customer.personalDetails && customer.personalDetails.taxCode !== undefined) ? customer.personalDetails.taxCode : newCode
        },
        validationSchema: Yup.object().shape({
            vatCode: Yup.string().min(12).max(13).trim().required('Required').test('RFC-check', content.update_receipt_number.validateRFC, value => validateRFC(value))
        }),
        onSubmit: submitCode
      })


    function validateRFC(value) {
        if (value) {
            if (value.match(/^[A-Za-z0-9]{12,13}$/)) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    async function fetchUpdateProduct() {
        setLoading(true)
        
        try {
            var updateProducts = await client.callApi('catalog','getUpdatePersonalDetails',[client.cache.catalogId])
            setUpdateProduct(updateProducts[0])
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }

    async function submitCode(values, form) {
        setLoading(true)
        // Do the API call to update the RFC Code
        var extendedData = {}
        extendedData.taxCode = values.vatCode
        extendedData.serviceLegacyId = client.cache.serviceLegacyId
        try {
            //create basket
            var order = await client.checkoutCustomerProduct(updateProduct, extendedData)
            console.log('order is: ');
            console.log(order);
            if (order.status === "failed"){
                //order failed, throw an exception to be caught
                throw new Error(content.menu.orderFailed)
            } else {
                customer.personalDetails.taxCode = values.vatCode
                client.setCache({customer})
                setLoading(false)
                navigation.navigate('Checkout')
            }
            
        } catch (error) {
            // product.category is undefined
            console.log('error is: ');
            console.log(error);
            const message = prettyErrorMessage(error, 'changeRFC', content)
            console.log('message is: ');
            console.log(message);
            form.setFieldError('vatCode', message)
            form.setSubmitting(false)
            setLoading(false)
        }

    }

    return (
        <View style={styles.container}>
            <Title style={styles.rfcTitle}>{content.update_receipt_number.title}</Title>
            <Space height={24}/>
            <View style={styles.text}>
                <TextInputExtended
                    label='RFC Code'
                    placeholder='0000000000'
                    onChangeText={formik.handleChange('vatCode')}
                    value={formik.values.vatCode}
                    error={formik.touched.vatCode && formik.errors.vatCode}
                    maxLength={13}
                    style={styles.rfcTextInput}
                    onSubmitEditing={formik.handleSubmit}   
                    selectionColor={colors.common}
                />
            </View>
            <Space height={24}/>
            <Button
                title={content.common.submit}
                disabled={!formik.dirty || !formik.isValid || formik.isSubmitting}
                onPress={formik.handleSubmit}
                style={styles.button}
                disabledStyle={styles.disabledButton}
                titleStyle={{...typography.extrabold, fontSize: 18}}
            />
            <ReturnFooter
                title={content.common.cancel}
                onPress={() => navigation.goBack()}
            />
        </View>
    )

}

const styles = StyleSheet.create({
    container: {
      flex: 1,
      alignItems:'center',
      justifyContent: 'center',
      ...adaptive.wrapperPadding
    },
    text: {
        width:'50%'
    },
    button: {
        width:'50%',
        backgroundColor: colors.srGreyBackground
    },
    disabledButton: {
        width:'50%',
        backgroundColor: colors.srGreyBackground + 50
    },
    rfcTextInput: {
        ...typography.demi
    },
    rfcTitle: {
        ...typography.demi
    }
})